import React from 'react';
import PropTypes from 'prop-types';

const CPD = (props) => (
    <div className="badge-cpd">
        <div className="badge-cpd-amount">{Number(props.amount)}</div>
        {props.format}
    </div>
);

CPD.propTypes = {
    amount: PropTypes.number.isRequired,
    format: PropTypes.string,
};

CPD.defaultProps = {
    format: 'pts'
};

export default CPD;
